/**
 * Cliente HTTP para avisos em modal do sistema.
 * Endpoints em /api/avisos-sistema (backend/routes/sistema/avisos_sistema_routes.py).
 */
import axios from 'axios';
import apiService from './core/apiService';
const BASE_URL = '/api/avisos-sistema';
function extrairMensagemErro(erro) {
    if (axios.isAxiosError(erro)) {
        const data = erro.response?.data;
        if (data?.mensagem)
            return data.mensagem;
        if (typeof erro.message === 'string')
            return erro.message;
    }
    if (erro instanceof Error)
        return erro.message;
    return 'Erro ao comunicar com o servidor';
}
function garantirSucesso(resposta, campoLista) {
    if (resposta?.status === 'erro') {
        throw new Error(resposta.mensagem || 'Operacao nao concluida');
    }
    if (campoLista === 'avisos' && Array.isArray(resposta.avisos)) {
        return resposta.avisos;
    }
    if (campoLista === 'aviso' && resposta.aviso !== undefined) {
        return resposta.aviso;
    }
    throw new Error('Resposta invalida do servidor');
}
export const avisosSistemaService = {
    /** Lista avisos (admin — requer sistema.gerenciar_avisos) */
    async listar(limite = 100) {
        try {
            const resposta = await apiService.get(BASE_URL, {
                params: { limite },
            });
            return garantirSucesso(resposta, 'avisos');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    /** Avisos pendentes do usuario logado (modal na entrada / socket) */
    async listarPendentes() {
        try {
            const resposta = await apiService.get(`${BASE_URL}/pendentes`);
            return garantirSucesso(resposta, 'avisos');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async criar(payload) {
        try {
            const resposta = await apiService.post(BASE_URL, payload);
            return garantirSucesso(resposta, 'aviso');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async atualizar(id, payload) {
        try {
            const resposta = await apiService.put(`${BASE_URL}/${id}`, payload);
            return garantirSucesso(resposta, 'aviso');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async disparar(id) {
        try {
            const resposta = await apiService.post(`${BASE_URL}/${id}/disparar`, {});
            return garantirSucesso(resposta, 'aviso');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    /** Ajusta prazo de exibicao em aviso ja disparado (ex.: corrigir fuso salvo errado) */
    async atualizarPrazoExibicao(id, exibir_ate) {
        try {
            const resposta = await apiService.patch(`${BASE_URL}/${id}/prazo-exibicao`, { exibir_ate });
            return garantirSucesso(resposta, 'aviso');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async cancelar(id) {
        try {
            const resposta = await apiService.post(`${BASE_URL}/${id}/cancelar`, {});
            return garantirSucesso(resposta, 'aviso');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async duplicar(id) {
        try {
            const resposta = await apiService.post(`${BASE_URL}/${id}/duplicar`, {});
            return garantirSucesso(resposta, 'aviso');
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async excluir(id) {
        try {
            const resposta = await apiService.delete(`${BASE_URL}/${id}`);
            if (resposta?.status === 'erro') {
                throw new Error(resposta.mensagem || 'Nao foi possivel excluir o aviso');
            }
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
    async confirmar(id) {
        try {
            const resposta = await apiService.post(`${BASE_URL}/${id}/confirmar`, {});
            if (resposta?.status === 'erro') {
                throw new Error(resposta.mensagem || 'Nao foi possivel confirmar o aviso');
            }
        }
        catch (erro) {
            throw new Error(extrairMensagemErro(erro));
        }
    },
};
export default avisosSistemaService;
